import React from "react"
import { LabelGroup } from "../components/display/LabelGroup"

export const UserDetails = ({
  userData: {
    data: { profile_url, username, level },
  },
  handleLogoutClick,
}) => {
  return (
    <section>
      <div className="user-details">
        <LabelGroup labelValue="User">
          <p>
            <a href={profile_url}>{username}</a>
          </p>
        </LabelGroup>
        <LabelGroup labelValue="Level">
          <p>{level}</p>
        </LabelGroup>
        <button className="api-key-btn" onClick={handleLogoutClick}>
          Logout{" "}
        </button>
      </div>
    </section>
  )
}
